export default __webpack_public_path__ + "static/media/email1.0683cc59.svg";